/**
 * Centralized analytics constants for the snippets package.
 *
 * All analytics events in this package use ANALYTICS_SOURCE as their source.
 * The origin attribute identifies which component/surface fired the event.
 * Action subjects and IDs identify the specific interaction.
 */

// ─── Source ──────────────────────────────────────────────────────────────────
/** Single source for all snippets analytics events */
export const ANALYTICS_SOURCE = 'confluenceSnippets';

// ─── Origins ─────────────────────────────────────────────────────────────────
/** Identifies which component/surface fired the event */
export const ANALYTICS_ORIGIN = {
	CREATE_SNIPPET_MODAL: 'createSnippetModal',
	SNIPPET_EDITOR_MODAL: 'snippetEditorModal',
	DELETE_SNIPPET_MODAL: 'deleteSnippetModal',
	SNIPPET_PANEL: 'snippetPanel',
	SNIPPET_GALLERY: 'snippetGallery',
} as const;

// ─── Action subjects (the "what") ────────────────────────────────────────────
export const ANALYTICS_SUBJECT = {
	BUTTON: 'button',
	FILTER: 'filter',
} as const;

// ─── Action subject IDs (the "which") ────────────────────────────────────────
export const ANALYTICS_SUBJECT_ID = {
	// button
	CREATE_SNIPPET: 'createSnippet',
	DELETE_SNIPPET: 'deleteSnippet',
	INSERTED: 'inserted',
	FAVORITE_TOGGLED: 'favoriteToggled',
	// filter
	CATEGORY: 'category',
	SEARCH: 'search',
	SORT_ORDER: 'sortOrder',
} as const;
